var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [_vm._v("Open Book Club")]), _vm._v(" "), _c('p', [_vm._v("Trade or loan books with other book readers in your area.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    Get started now by\n    "), _c('router-link', {
    attrs: {
      "to": "/books-add"
    }
  }, [_vm._v("Creating your own collection")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": "/books"
    }
  }, [_vm._v("Finding books for you")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b51d27b2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 66
// module chunks = 0